
export const dashboardNotes = [
    "The data presented reflects the transactional status recorded as of the latest system update.",
    "Asterisk (*) alongside titles indicates that figures are subject to final reconciliation.",
    "Reported numbers are calculated based on unique application IDs across all service modes.",
    "Pending counts include all applications currently in the workflow across diverse roles.",
];

export default {
  form: {
      uploadNote:
      "Note: Upload File within 2 MB accept only jpg, jpeg and png format"
  },
};
